// src/pages/fullServiceInvoice/component/FullServiceKmTable.jsx

import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';
import { useLanguage } from '../../../../contexts/LanguageContext';
import useFullServiceKm from '../hooks/useFullServiceKmData';
import { confirmDialog } from 'primereact/confirmdialog';
import toastService from '../../../../utils/toastService';
import { STATUS_META } from '../hooks/useFullServiceKmData';

const FullServiceKmTable = ({ fullServiceId, onEditClick, isCanUseFullService, invoiceDetail }) => {
    const { th, language } = useLanguage();

    const { kms, totalCount, loading, lazyParams, onPage, onSort, handleDeleteKm } = useFullServiceKm(fullServiceId);

    const actionTemplate = (rowData) => (
        <div className="flex gap-2 justify-content-center">
            <i onClick={() => onEditClick?.(rowData)} className="pi pi-pencil cursor-pointer text-blue-500 hover:text-blue-700" style={{ fontSize: '1.1rem', color: '#0B3187' }} title={th('fullServiceInvoice.tooltips.edit')} />
        </div>
    );

    const dateBody = (rowData, col) => {
        const v = rowData[col.field];
        if (!v) return '';
        const d = new Date(v);
        return d.toLocaleDateString(language?.locale || 'tr-TR');
    };

    const priceBody = (rowData) => {
        const value = rowData.price ?? 0;
        return value.toLocaleString(language?.locale || 'tr-TR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 4
        });
    };

    const workflowStatusBody = (rowData) => {
        const code = Number(rowData?.status);
        const meta = STATUS_META[code];

        if (!meta) {
            return <Tag value={String(rowData?.status ?? '-')} severity="secondary" rounded />;
        }
        return (
            <div className="flex align-items-center gap-2">
                {/* Adım etiketi */}
                <Tag value={meta.label} severity={meta.severity} rounded />
            </div>
        );
    };
    return (
        <DataTable
            value={kms}
            paginator
            rows={lazyParams.rows}
            totalRecords={totalCount}
            first={lazyParams.first}
            lazy
            onPage={onPage}
            onSort={onSort}
            sortField={lazyParams.sortField}
            sortOrder={lazyParams.sortOrder}
            loading={loading}
            emptyMessage={th('fullServiceInvoice.emptyMessage')}
            className="p-datatable-gridlines"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            rowsPerPageOptions={[5, 10, 25, 50, 100]}
            sortMode="single"
            removableSort
        >
            <Column body={actionTemplate} header={th('fullServiceInvoice.columns.actions')} style={{ width: '8%' }} align="center" alignHeader="center" />
            <Column field="contractStartDate" header={th('fullServiceInvoiceKm.columns.contractStartDate')} body={dateBody} sortable />
            <Column field="contractEndDate" header={th('fullServiceInvoiceKm.columns.contractEndDate')} body={dateBody} sortable />
            <Column field="km" header={th('fullServiceInvoiceKm.columns.km')} sortable />
            {!isCanUseFullService && <Column field="price" header={th('fullServiceInvoiceKm.columns.price')} body={priceBody} sortable />}
            {!isCanUseFullService && invoiceDetail?.dealerType === 1 && (
                <Column
                    field="priceWithKDV"
                    header={th('fullServiceInvoiceKm.columns.priceWithKDV')}
                    body={(rowData) => {
                        const value = rowData.priceWithKDV ?? 0;
                        return value.toLocaleString(language?.locale || 'tr-TR', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 4
                        });
                    }}
                    sortable
                />
            )}
            <Column field="currency" header={th('fullServiceInvoiceKm.columns.currency')} sortable />
            <Column field="status" header={th('fullServiceInvoiceKm.columns.status')} body={workflowStatusBody} sortable style={{ width: '18rem' }} />
            <Column field="description" header={th('fullServiceInvoiceKm.columns.description')} sortable />
        </DataTable>
    );
};

export default FullServiceKmTable;
